module.exports = __webpack_public_path__ + "img/rukavy_81_cerna.2df58b24.png";